import { render, staticRenderFns } from "./vipManagement.vue?vue&type=template&id=e200e49c&"
import script from "./vipManagement.vue?vue&type=script&lang=js&"
export * from "./vipManagement.vue?vue&type=script&lang=js&"
import style0 from "./vipManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports